import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/design/blob/multi-layer-blob.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GradientButton"] */ "/vercel/path0/src/components/design/gradient-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/areas/areas-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextCarousel"] */ "/vercel/path0/src/components/home/hero/hero-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/journey/journey-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/testimonials/testimonial-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselContent","CarouselItem","CarouselPrevious","CarouselNext"] */ "/vercel/path0/src/components/ui/carousel.tsx");
